module.exports = __webpack_public_path__ + "img/P1070844.c62cff32.jpg";